<div class="top-bar">
  <h1 class="top-bar__title">{{ 'TEAMS.LABEL' | translate }}</h1>
  <app-select-market></app-select-market>
</div>

<div class="page teams-page">
  <div class="page-toolbar">
    <div class="page-toolbar__start search">
      <df-input type="search" block prefixIcon="heroMagnifyingGlass" allowClear [placeholder]="'UI.SEARCH.TEAM' | translate"
        [value]="textFilter" (valueChange)="textFilter = $event; filterTeams(true)" />
    </div>
    <div class="page-toolbar__end">
      <df-button variant="primary" icon="heroPlus" (onClick)="openAddTeamModal()">{{ 'TEAM.NEW' | translate }}</df-button>
    </div>
  </div>

  <div class="card">
    @if (displayedTeams?.length) {
      <table class="data-table">
        <thead>
          <tr>
            <th>{{ 'TEAM.ACTIVATED' | translate }}</th>
            <th>{{ 'UI.ROLES' | translate }}</th>
            <th>{{ 'TEAM.MEMBER' | translate }}</th>
            <th>{{ 'TEAM.FIRST_NAME' | translate }}</th>
            <th>{{ 'TEAM.LAST_NAME' | translate }}</th>
            <th>{{ 'TEAM.LANGUAGE' | translate }}</th>
            <th>{{ 'TEAM.PHONE' | translate }}</th>
            <th>{{ 'TEAM.EMAIL' | translate }}</th>
            <th>{{ 'TEAM.LOCATION' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (team of paginatedTeams; track team) {
            @let isExternal = team.teamMemberId?.toUpperCase().startsWith('EXT');
            <tr [class.inactive]="!team.isActivated">
              <td>
                <input type="checkbox" class="switch"
                  [checked]="team.isActivated"
                  (change)="toggleTeamActivation(team)"/>
              </td>
              <td>
                <div class="roles">
                  @for (role of roles; track role) {
                    @let roleLocked = isExternal && role.rolename === TEAM_ROLES.REMOTE_SUPERVISION;
                    <button type="button" class="toggle-chip"
                      [class.active]="team.hasRole(role.rolename)"
                      [disabled]="roleLocked"
                      (click)="updateRole($event, team, role)">
                      <ng-icon [name]="role.icon" size="14"/>
                      {{ role.label | translate }}
                    </button>
                  }
                </div>
              </td>
              <td>
                @if (isExternal) {
                  <span class="tag">{{ 'TEAM.EXTERNAL' | translate }}</span>
                } @else {
                  <span class="cell-strong">{{ team.teamMemberId }}</span>
                }
              </td>
              <td>{{ team.teamMemberFirstName }}</td>
              <td>{{ team.teamMemberName }}</td>
              <td>{{ team.teamMemberLanguage }}</td>
              <td class="nowrap">{{ team.teamMemberCellularPhone }}</td>
              <td class="cell-muted">{{ team.teamMemberEmail }}</td>
              <td>{{ team.peoplelocationname }}</td>
              <td class="cell-actions">
                <button type="button" class="icon-action" title="Edit" (click)="openUpdateTeamModal(team)">
                  <ng-icon name="heroPencilSquare" size="18"/>
                </button>
                <button type="button" class="icon-action danger" title="Delete" (click)="removeTeam(team)">
                  <ng-icon name="heroTrash" size="18"/>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (displayedTeams.length > pageSize) {
        <div class="pagination" aria-label="Team pages">
          <span class="pagination__summary">Page {{ currentPage }} of {{ pageCount }}</span>
          <div class="pagination__actions">
            <button type="button" class="pagination__button" [disabled]="currentPage === 1"
              aria-label="Previous page" (click)="setPage(currentPage - 1)">Previous</button>
            <button type="button" class="pagination__button" [disabled]="currentPage === pageCount"
              aria-label="Next page" (click)="setPage(currentPage + 1)">Next</button>
          </div>
        </div>
      }
    } @else {
      <div class="empty-state">
        <ng-icon name="heroUsers" size="32"/>
        <div class="empty-state__title">{{ 'UI.EMPTY.TEAMS' | translate }}</div>
        <div class="empty-state__text">{{ 'UI.EMPTY.TEAMS_MARKET' | translate }}</div>
      </div>
    }
  </div>
</div>

@if (addingTeam) {
  <app-create-team
    [market]="selectedMarket"
    (closeModal)="closeAddTeamModal($event)">
  </app-create-team>
}

@if (teamToUpdate) {
  <app-update-team
    [team]="teamToUpdate"
    [market]="selectedMarket"
    (closeModal)="closeUpdateTeamModal($event)">
  </app-update-team>
}
